import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";
import { timeFormatter } from "web_myplann/Shared/Utils/timeFormatter";

export const formatTaskDueDate = (
	date: string | null | undefined,
	time: string | null | undefined,
): string =>
	date ? `${dateFormatter(date)} ${timeFormatter(time)}`.trim() : "";
